import { IBaseAction, PaginationQuery, configuration } from '../../constants';
import { ChipDataState } from '../table/types';

export type PanelViewState =
    | 'DEFAULT'
    | 'BAR'
    | 'PIE'
    | 'TABLE'
    | 'HORIZONTAL_BAR'
    | 'SIMPLE_TABLE'
    | 'NUMERIC_TABLE'
    | 'AREA'
    | 'LINEAR';

export const defaultHiddenColumns = configuration.DEFAULT_HIDDEN_COLUMNS;
export const CHANGE_HIDDEN_COLUMNS = 'CHANGE_HIDDEN_COLUMNS';
export const CHANGE_HIDDEN_COLUMNS_ALL = 'CHANGE_HIDDEN_COLUMNS_ALL';
export interface HiddenColumns {
    data: Array<string>;
}
export type HiddenColumnsState = { [key in string]: Array<string> };
interface ChangeHiddenColumnsAction extends IBaseAction {
    type: typeof CHANGE_HIDDEN_COLUMNS | typeof CHANGE_HIDDEN_COLUMNS_ALL;
    payload: {
        data: HiddenColumnsState;
        id: string;
    };
    requestPayload?: {
        id: string
    }
}

//********************************/

export const defaultColumnsOrder = configuration.DEFAULT_COLUMNS_ORDER;
export const CHANGE_COLUMNS_ORDER = 'CHANGE_COLUMNS_ORDER';
export const CHANGE_COLUMNS_ORDER_ALL = 'CHANGE_COLUMNS_ORDER_ALL';
export interface ColumnsOrder {
    data: Array<string>;
}
export type ColumnsOrderState = { [key in string]: Array<string> };
interface ChangeColumnsOrderAction extends IBaseAction {
    type: typeof CHANGE_COLUMNS_ORDER | typeof CHANGE_COLUMNS_ORDER_ALL;
    payload: {
        data: ColumnsOrderState;
        id: string;
    };
    requestPayload?: {
        id: string
    }
}

//********************************/
export const defaultSelectedFilters = configuration.DEFAULT_SELECTED_FILTERS;
export const CHANGE_SELECTED_FILTERS = 'CHANGE_SELECTED_FILTERS';
export const CHANGE_SELECTED_FILTERS_ALL = 'CHANGE_SELECTED_FILTERS_ALL';
export interface SelectedFilters {
    data: ChipDataState;
}
export type SelectedFiltersState = { [key in string]: ChipDataState };
interface ChangeSelectedFiltersAction extends IBaseAction {
    type: typeof CHANGE_SELECTED_FILTERS | typeof CHANGE_SELECTED_FILTERS_ALL;
    payload: {
        data: SelectedFiltersState;
        id: string;
    };
    requestPayload?: {
        id: string
    }
}


//********************************/

export interface MenuItemProps {
    type: string;
    payload: any;
}

export interface PanelMeunuProps {
    view: PanelViewState;
    //panel: Panel,
    handleMenuClose: any;
    onPanelChange: any;
    onMenuItemClick?: any;
}

//********************************/

export interface FlightDetails {
    type: string;
    airline: string;
    incoming: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    requestNumber: string;
}

export interface Flight {
    type: string;
    airline: string;
    incoming: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    requestNumber: string;
    status: string;
}

export interface FlightRequest {
    type: string;
    airline: string;
    flights: Flight[];
    generatedFlights: Flight[];
    status: string;
    instanceId: string;
    taskId: string;
    candidateGroup: string;
    type_desc: string;
    requestNumber: string;
    rpl?: any;
    submitDate: Date;
}


export interface SelectedRequests {
    data: Array<FlightRequest>;
}
export type SelectedRequestsState = { [key in string]: Array<FlightRequest> };

export const CHANGE_SELECTED_REQUESTS = 'CHANGE_SELECTED_REQUESTS';
export const CHANGE_SELECTED_REQUESTS_ALL = 'CHANGE_SELECTED_REQUESTS_ALL';

interface ChangeSelectedRequestsAction extends IBaseAction {
    type: typeof CHANGE_SELECTED_REQUESTS | typeof CHANGE_SELECTED_REQUESTS_ALL;
    payload: {
        data: SelectedRequestsState;
        id: string;
    };
    requestPayload?: {
        id: string
    }
}

export interface FlightRequestsListState {
    data: FlightRequest[];
    total: 0;
}

//export type FlightRequestsListState = Array<FlightRequest>;
export interface FlightRequestsListInitialState {
    flightRequests: Array<FlightRequest>;
}
export const FLIGHT_REQUEST_LIST = 'FLIGHT_REQUEST_LIST';
export const FLIGHT_REQUEST_LIST_SUCCESS = 'FLIGHT_REQUEST_LIST_SUCCESS';
export const FLIGHT_REQUEST_LIST_FAILURE = 'FLIGHT_REQUEST_LIST_FAILURE';
interface GetFlightRequestsList extends IBaseAction {
    type: typeof FLIGHT_REQUEST_LIST | typeof FLIGHT_REQUEST_LIST_SUCCESS | typeof FLIGHT_REQUEST_LIST_FAILURE;
    payload: {
        data: FlightRequestsListInitialState;
    };
}

//********************************/
export const REMOVE_FLIGHT_REQUESTS = 'REMOVE_FLIGHT_REQUESTS';
export const REMOVE_FLIGHT_REQUESTS_SUCCESS = 'REMOVE_FLIGHT_REQUESTS_SUCCESS';
export const REMOVE_FLIGHT_REQUESTS_FAILURE = 'REMOVE_FLIGHT_REQUESTS_FAILURE';
interface RemoveFlightRequests extends IBaseAction {
    type: typeof REMOVE_FLIGHT_REQUESTS | typeof REMOVE_FLIGHT_REQUESTS_SUCCESS | typeof REMOVE_FLIGHT_REQUESTS_FAILURE;
    payload: {
        error?: string;
        data?: string;
    };
}
//********************************/
export class GetFlightRequestsListQuery extends PaginationQuery {
    // terminalId: number | null = null;
    // queueId: number | null = null;
    // announceDateTo: Date | null = null;
    // announceDateFrom: Date | null = null;
    // dateFrom: Date | null = null;
    // dateTo: Date | null = null;
    // repetitionNum: number | null = null;
    // flightNumber: string | null = null;

    constructor() {
        super();
    }
}

interface AnnouncedRecord { }
export interface AnnouncedRecordList {
    rows: Array<AnnouncedRecord>;
    rowCount: number;
}
export const GET_ANNOUNCEMENT_LIST = 'GET_ANNOUNCEMENT_LIST';
export const GET_ANNOUNCEMENT_LIST_SUCCESS = 'GET_ANNOUNCEMENT_LIST_SUCCESS';
interface GetAnnouncedRecordsListAction extends IBaseAction {
    type: typeof GET_ANNOUNCEMENT_LIST | typeof GET_ANNOUNCEMENT_LIST_SUCCESS;
    payload: {
        data: AnnouncedRecordList;
    };
}

export interface AnnouncedFlight {
    announceDateFrom?: Date;
    announceDateTo?: Date;
    announceType?: string;
    announceTypeDesc?: string;
    announceTypeDesc2?: string;
    announced_by?: string;
    announced_by_name: string;
    channelName: string;
    contentLink: string;
    dateFrom: Date;
    dateTo: Date;
    dequeueDate: Date;
    dequeueType: string;
    dequeueTypeDesc: string;
    dequeuedBy: string;
    enqueueDate: Date;
    enqueuedBy: string;
    extension: string;
    extensionId: number;
    flightNumber: string;
    id: number;
    queueDesc: string;
    queueId: number;
    repetitionNum: number;
    terminalId: number;
    terminalName: string;
    voiceFileName: string;
    zones: string;
}

export type AnnouncedFlightState = { [key in number]: AnnouncedFlight };
export const GET_ANNOUNCED_FLIGHT = 'GET_ANNOUNCED_FLIGHT';
export const GET_ANNOUNCED_FLIGHT_SUCCESS = 'GET_ANNOUNCED_FLIGHT_SUCCESS';
interface GetAnnouncedFlightAction extends IBaseAction {
    type: typeof GET_ANNOUNCED_FLIGHT | typeof GET_ANNOUNCED_FLIGHT_SUCCESS;
    payload: {
        data: AnnouncedFlightState;
    };
}

export const FLIGHT_STATUS = 'FLIGHT_STATUS';
export const FLIGHT_STATUS_SUCCESS = 'FLIGHT_STATUS_SUCCESS';
interface GetFlightStatusAction extends IBaseAction {
    type: typeof FLIGHT_STATUS | typeof FLIGHT_STATUS_SUCCESS;
    payload: {
        data: any;
    };
}

export type FlightRequestsActionTypes =
    | GetAnnouncedFlightAction
    | GetFlightRequestsList
    | GetAnnouncedRecordsListAction
    | ChangeHiddenColumnsAction
    | ChangeSelectedRequestsAction
    | RemoveFlightRequests
    | ChangeSelectedFiltersAction
    | ChangeColumnsOrderAction
    | GetFlightStatusAction;
